import {
  listFormulaCards,
  listFormulaCardTypeMappings,
  getFormulaCard,
  listSalaryComponents,
  listEntries,
  getPreview,
} from './queries';
import {
  createFormulaCard,
  updateFormulaCard,
  updateEntries,
  updateComponent,
  bulkUpdateSalaryComponents,
  deleteFormulaCard,
  createFormulaCardTypeMapping,
} from './mutations';

const queries = {
  listFormulaCards,
  listFormulaCardTypeMappings,
  getFormulaCard,
  listSalaryComponents,
  listEntries,
  getPreview,
};

const mutations = {
  createFormulaCard,
  updateFormulaCard,
  updateEntries,
  updateComponent,
  bulkUpdateSalaryComponents,
  deleteFormulaCard,
  createFormulaCardTypeMapping,
};

export const overtimeApis = {
  queries,
  mutations,
};
